/* global graphql  */
import PropTypes from 'prop-types'
import React from 'react'
import Helmet from 'react-helmet'
import Header from '../components/header-new'
import Footer from '../components/footer-new'

const ContactPage = ({ data }) => (
  <div className='wrapper--page page--contact'>
    <Helmet title='Contact Us - ATTN:' />
    <Header theme='dark' />
    <div className='contact__hero'>
      <img
        className='contact__hero--desktop'
        src={data.drupalMedia.image_desktop.url}
      />
      <img
        className='contact__hero--mobile'
        src={data.drupalMedia.image_mobile.url}
      />
    </div>
    <div className='wrapper--max-width contact__details'>
      <div className='col'>
        <div className='contact__info'>
          <p>General</p>
          <a href='mailto:info@attn.com'>info@attn.com</a>
          <span className='contact__address'>
            5700 Wilshire Blvd Suite 375<br />Los Angeles, CA 90036
          </span>
        </div>
      </div>
      <div className='col'>
        <div className='contact__info'>
          <p>Press</p>
          <a href='mailto:press@attn.com'>press@attn.com</a>
        </div>
        <div className='contact__info'>
          <p>Advertising</p>
          <a href='mailto:brands@attn.com'>brands@attn.com</a>
        </div>
        <div className='contact__info'>
          <p>Branded partnerships</p>
          <a href='mailto:partnerships@attn.com'>partnerships@attn.com</a>
        </div>
      </div>
    </div>
    <Footer />
  </div>
)

ContactPage.propTypes = {
  data: PropTypes.object
}

export default ContactPage

export const query = graphql`
  query ContactPage {
    drupalMedia(pid: {eq: "125"}) {
      image_desktop {
        url
      }
      image_mobile {
        url
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/contact.js